import React from "react";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const About = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (isMobile) {
    return (
      <div className="mobile-about-page-wrapper">
        <div></div>
      </div>
    );
  }
  return (
    <div className="page-wrapper">
      <div className="page-hero-text-wrapper">
        <div className="page-hero-text">About Us</div>
      </div>
      <div className="page-body-wrapper">
        <div className="about-page-body-content-wrapper">
          <div className="about-page-body-text-wrapper">
            <div className="about-page-body-title">Who We Are</div>
            <div className="about-page-body-text">
              At S.B. Sharma & Associates, we are driven by a passion for
              excellence and a commitment to delivering outstanding value. What
              began as a simple idea has grown into a dedicated venture built on
              trust, expertise, and customer-focused solutions. Our journey is
              rooted in a deep understanding of our clients’ needs and a desire
              to make a meaningful impact in the industry we serve.
            </div>
            <div className="about-page-body-text">
              Over the years, we’ve built a reputation for professionalism,
              transparency, and reliability. Our team is made up of experienced
              individuals who bring diverse perspectives and skills to the
              table. Together, we strive to innovate, adapt, and lead—always
              placing the interests of our clients at the heart of everything we
              do.
            </div>
            <div className="about-page-body-text">
              We believe in creating lasting relationships through quality
              service, honest communication, and consistent results. Whether
              you're seeking guidance, solutions, or support, We stand ready to
              partner with you every step of the way. We're proud of where we
              started, excited about where we’re going, and honored to be part
              of your journey.
            </div>
          </div>
          <div className="about-page-body-image-wrapper">
            <div className="about-page-body-image-wrapper-img">
              <img
                className="about-page-body-image-wrapper-img"
                src="/Stock Images/group-photo.jpg"
                alt="About-img"
              />
            </div>
          </div>
        </div>

        <div className="about-page-cards-wrapper">
          <div className="about-page-card-wrapper">
            <div className="about-page-card-title">Our Mission</div>
            <div className="about-page-card-img-wrapper">
              <img className="about-page-card" src="" alt=""></img>
            </div>
          </div>
          <div className="about-page-card-wrapper">
            <div className="about-page-card-title">Our Philosophy</div>
            <div className="about-page-card-img-wrapper">
              <img className="about-page-card" src="" alt=""></img>
            </div>
          </div>
          <div className="about-page-card-wrapper">
            <div className="about-page-card-title">Our Team</div>
            <div className="about-page-card-img-wrapper">
              <img className="about-page-card" src="" alt=""></img>
            </div>
          </div>
        </div>

        <div className="about-page-career-wrapper">
          <div className="about-page-career-title">Interested?</div>
          <div className="about-page-career-body-wrapper">
            <div className="about-page-career-body">
              At S.B. Sharma & Associates, we’re committed to integrity,
              precision, and helping you grow in your audit career. If you’re
              driven and detail-focused, explore how you can make an impact with
              us.
            </div>
            <Link to="/career">
              <div className="about-page-career-link">Learn More</div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
